import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Data$dRational$dExtra from "../Data.Rational.Extra/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
const editAsStringString = {toString: x => x, parse: Data$dEither.Right};
const editAsStringRational = {
  toString: Data$dRational$dExtra.toStringR,
  parse: s => {
    const $0 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.invalid_rational), {});
    const $1 = Data$dRational$dExtra.fromString(s);
    if ($1.tag === "Nothing") { return Data$dEither.$Either("Left", $0); }
    if ($1.tag === "Just") { return Data$dEither.$Either("Right", $1._1); }
    $runtime.fail();
  }
};
const editAsStringNumber = {
  toString: Data$dShow.showNumberImpl,
  parse: s => {
    const $0 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.invalid_number), {});
    const $1 = Data$dNumber.fromStringImpl(s, Data$dNumber.isFinite, Data$dMaybe.Just, Data$dMaybe.Nothing);
    if ($1.tag === "Nothing") { return Data$dEither.$Either("Left", $0); }
    if ($1.tag === "Just") { return Data$dEither.$Either("Right", $1._1); }
    $runtime.fail();
  }
};
const editAsStringMoney = {
  toString: Data$dMoney$dRounded.toString,
  parse: s => {
    const $0 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.invalid_money), {});
    const $1 = Data$dMoney$dRounded.fromString(s);
    if ($1.tag === "Nothing") { return Data$dEither.$Either("Left", $0); }
    if ($1.tag === "Just") { return Data$dEither.$Either("Right", $1._1); }
    $runtime.fail();
  }
};
const editAsStringInt = {
  toString: Data$dShow.showIntImpl,
  parse: s => {
    const $0 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.invalid_int), {});
    const $1 = Data$dInt.fromString(s);
    if ($1.tag === "Nothing") { return Data$dEither.$Either("Left", $0); }
    if ($1.tag === "Just") { return Data$dEither.$Either("Right", $1._1); }
    $runtime.fail();
  }
};
const toString = dict => dict.toString;
const parse = dict => dict.parse;
const editAsStringMaybe = dictEditAsString => (
  {
    toString: v2 => {
      if (v2.tag === "Nothing") { return ""; }
      if (v2.tag === "Just") { return dictEditAsString.toString(v2._1); }
      $runtime.fail();
    },
    parse: v => {
      if (v === "") { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
      const $0 = dictEditAsString.parse(v);
      if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
      if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", $0._1)); }
      $runtime.fail();
    }
  }
);
export {editAsStringInt, editAsStringMaybe, editAsStringMoney, editAsStringNumber, editAsStringRational, editAsStringString, parse, toString};
